import { Dispatch, SetStateAction, useRef } from 'react';
import type { UploadHubListItem } from 'api/hooks/useUploadFiles';
import UploadHubFileDropzone from 'components/UploadHub/UploadHubFileDropzone';
import { getFileBadge } from 'components/UploadHub/fileTypeBadges';
import { UploadHubModalMode } from 'components/UploadHub/UploadHubModalAdd';

interface UploadHubFileFieldProps {
  mode: UploadHubModalMode;
  editingFile?: UploadHubListItem | null;
  pendingFiles: File[];
  setPendingFiles: Dispatch<SetStateAction<File[]>>;
  fileRemoved: boolean;
  setFileRemoved: (value: boolean) => void;
  onFilesAdded: (files: File[]) => void;
}

const UploadHubFileField = (props: UploadHubFileFieldProps) => {
  const { mode, editingFile, pendingFiles, setPendingFiles, fileRemoved, setFileRemoved, onFilesAdded } = props ?? {};
  const replaceInputRef = useRef<HTMLInputElement>(null);

  if (mode === 'editFile' && editingFile && !fileRemoved && pendingFiles.length === 0) {
    const badge = getFileBadge({ contentType: editingFile.contentType });
    const originalFileName = decodeURIComponent(
      editingFile.url.split('/').pop()?.split('?')[0] ?? editingFile.fileName
    );
    return (
      <>
        <ul className='policy-list px-0 mb-3'>
          <li className='border-main-blue-50 box-rounded d-flex justify-content-between mb-3 align-items-center'>
            <div className='d-flex align-items-center'>
              <p className='attachment-name mb-0 flex-centered'>
                <span
                  className={`mr-2 font-weight-bold upload-hub-file-icon upload-hub-file-icon-sm ${badge.className} text-white text-center flex-centered justify-content-center`}
                >
                  {badge.label}
                </span>
                {originalFileName}
              </p>
            </div>
            <div className='px-2'>
              <label
                htmlFor='uploadHubReplaceFileInput'
                className='general-button circle-button circle-button-36 hovered-button specific-top-padding-1 specific-bottom-padding-2 paragraph-p2 specific-x-padding-10 flex-centered mb-0 pointer'
              >
                <span className='icon-edit-pencil' />
              </label>
              <input
                ref={replaceInputRef}
                id='uploadHubReplaceFileInput'
                type='file'
                hidden
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setPendingFiles([file]);
                    setFileRemoved(true);
                    onFilesAdded([file]);
                  }
                  if (replaceInputRef.current) replaceInputRef.current.value = '';
                }}
              />
            </div>
          </li>
        </ul>
      </>
    );
  }

  return (
    <UploadHubFileDropzone
      pendingFiles={pendingFiles}
      setPendingFiles={setPendingFiles}
      multiple={false}
      onFilesAdded={(files) => {
        setFileRemoved(true);
        onFilesAdded(files);
      }}
    />
  );
};

export default UploadHubFileField;
